import { Box, styled } from "@mui/material";

export const PreviewColumn = styled(Box)(({ theme }) => ({
  flex: "1 1 50%",
  minWidth: 0,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  backgroundColor: theme.palette.background["paper-elevation-reversed"],
  padding: theme.spacing(4),
  [theme.breakpoints.down("md")]: {
    flex: "1 1 auto",
    width: "100%",
  },
}));

export const PreviewSections = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(6),
}));

export const PreviewStack = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: theme.spacing(4),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  paddingTop: theme.spacing(7),
  paddingBottom: theme.spacing(4),
}));
